module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/purebarre-9bbd77f963828faa705cbcc06768492c.png";